import PrimaryButton from 'components/form/button/PrimaryButton';
import './premiumSuspendedScreen.scss';
import DraggablePopup from 'components/widgets/draggable-popup/DraggablePopup';
import { FormattedMessage } from 'react-intl';
import PremiumDetailItem from '../detail-item/PremiumDetailIem';
import PremiumAdvantages from '../advantages/PremiumAdvantages';

interface PremiumStatusScreenProps {
    premiumSince: string | null;
    shouldShow: boolean;
    onClose: () => void;
}

const PremiumSuspendedScreen = ({ premiumSince, shouldShow, onClose }: PremiumStatusScreenProps) => (
    <DraggablePopup
        show={shouldShow}
        shouldShowHandle={false}
        isDraggable={false}
        closeOnBackdropClick
        onClose={onClose}
        wrapperStyle={{ maxHeight: 'unset' }}
    >
        <section className="premium-suspended-screen">
            <h1><FormattedMessage id="premium.overview.title" /></h1>

            <PremiumDetailItem className="premium-suspended-item" title="Membre depuis:" value={premiumSince ?? 'N/A'} />
            <PremiumDetailItem className="premium-suspended-item" title="Economies réalisée" />

            <div className="line" />
            <PremiumAdvantages isSuspended/>

            <PrimaryButton className="premium-suspended-action" type="button" onClick={onClose}>
                    Ok
            </PrimaryButton>
        </section>
    </DraggablePopup>
);

export default PremiumSuspendedScreen;
